import React from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-ink-border bg-ink px-5 py-8" data-id="element-123" data-mp="208caozdh8xmx">
      <div className="mx-auto max-w-4xl text-center" data-id="element-124" data-mp="2f4jsxu5brozk">
        <p className="font-display text-xl uppercase tracking-wide text-white" data-id="element-125" data-mp="2f421rbxis0yi">
          Aula Baile <span className="rounded border border-white/70 px-1.5 py-0.5 text-sm" data-id="element-126" data-mp="2a69zpp35uygl">Pro</span>
        </p>
        <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-127" data-mp="1mgny6uzbg75f">Megapack Zumba Pro</p>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/60" data-id="element-128" data-mp="1heynjgg09vhv">
          <a href="#soporte" className="inline-flex items-center gap-1 hover:text-lime" data-id="element-129" data-mp="1w7sh25s44c5j">
            <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-130" data-mp="1rd62jtqqi3h8" /> Soporte
          </a>
          <a href="#contacto" className="inline-flex items-center gap-1 hover:text-lime" data-id="element-131" data-mp="13ntx94yj2fk7">
            <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-132" data-mp="yq22m36i0fcb" /> Contacto
          </a>
          <a href="#terminos" className="hover:text-lime" data-id="element-133" data-mp="1ehkf4hq7nnag">Términos y condiciones</a>
        </div>

        <p className="mx-auto mt-5 max-w-2xl text-xs leading-relaxed text-white/40" data-id="element-134" data-mp="1ii4ezt26550a">
          Este producto no reemplaza la certificación oficial de instructor. Los resultados dependen del compromiso de cada profesor/a. © {new Date().getFullYear()} Megapack Zumba Pro. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}